import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.css';
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import lozad from 'lozad';
import IMask from 'imask';

window.Choices = Choices;

window.Swiper = Swiper;
window.lozad = lozad;
window.IMask = IMask;

export { Choices, Swiper, lozad, IMask };
